import Vue from 'vue'
import Vuex from 'vuex'

Vue.config.devtools = true

import contentState from '../lib/content-state'

import { createAudioPlugin } from './plugins/audio'
import audio from './modules/audio'
import date from './modules/date'
import ui from './modules/ui'

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [ createAudioPlugin() ],
  modules: { audio, ui, date, content: contentState.mod }
})